import { iframeMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [iframeMock];

export const catalogueConsultationMock: SlugPage = {
  ...pageBase({
    title: 'Catalogue - consultation',
    type: 'catalogue-iframe', // Changed to specific type for promotion exclusion
    language: 'fr-FR',
    headerId: '',
    footerId: null,
    isBreadcrumbOverlay: false,
  }),
  config: {
    ...pageBase({
      title: 'Catalogue - consultation',
      type: 'catalogue-iframe',
      language: 'fr-FR',
      headerId: '',
      footerId: null,
      isBreadcrumbOverlay: false,
    }).config,
    breadcrumb: {
      isOverlay: false,
      items: [],
    },
  },
  blocks,
};
